<template>
	<div class="btn-container" :class="['el-'+details.id]">
		<v-style>
			{{ css }}
		</v-style>
    <a
        v-if="addedClass !== 'single_item'"
        :href="linkUrl"
        :target="linkTarget"
        :id="advanced.cssId"
        :class="['btn', advanced.cssClasses, advanced.displayType, responsiveClasses]"
        :style="style"
    >
        <span class="btn-headline" :style="headlineStyle">{{basic.content || ''}}</span>
        <div v-if="basic.subHeadline" class="btn-sub-headline" :style="subStyle">
            {{basic.subHeadline}}
        </div>
    </a>
    <a
        v-else
        :id="advanced.cssId"
        :class="['btn', advanced.cssClasses, addedClass, advanced.displayType, responsiveClasses]"
        :href="linkUrl"
        :target="linkTarget"
        :style="style">
        <span class="btn-headline" :style="headlineStyle">{{basic.content || ''}}</span>
        <div
            v-if="basic.subHeadline"
            class="btn-sub-headline"
            :style="subStyle"
        >
            {{basic.subHeadline}}
        </div>
    </a>
	</div>
</template>

<script>
import {
	boxShadow, textShadow, multiTextShadow, fontProps, getPadding, borderProps, responsiveAlignStyles, hoverFontProps
} from "@/modules/page-editor/src/utils/props";
import {linkTarget, linkUrl} from "@/helpers/actionData";

export default {
    name: 'EmailButton',
    props: ['details','addedClass'],
    computed: {
        basic() {
            return this.details.attributes.basic
        },
        advanced() {
            return this.details.attributes.advanced
        },
        responsive() {
            return this.details.responsive
        },
        responsiveClasses() {
            let c = '';
            if (!this.responsive) return '';
            if (!this.responsive.desktop) c = 'no-desktop';
            if (!this.responsive.mobile) c += ' no-mobile';
            if (!this.responsive.tablets) c += ' no-tablet';
            return c;
        },
	    linkUrl() {
        	return linkUrl(this.basic.linkUrl);
	    },
	    linkTarget() {
		    return linkTarget(this.basic.linkUrl);
	    },
	    css() {
        	return responsiveAlignStyles(this.basic.align, this.details.id);
	    },
        // subStyle() {
        //     return {
        //     	...fontProps(this.basic.font2),
        //     }
        // },
	    subStyle() {
		    return {
			    ...fontProps(this.basic.font2),
			    marginTop: (this.basic.lineSpacing && this.basic.lineSpacing.number) ? this.basic.lineSpacing.number+'px' : null,
		    }
	    },
	    headlineStyle() {
		    return { ...fontProps(this.basic.font) }
	    },
        style() {
            return {
	            ...borderProps(this.basic.border),
                margin: getPadding(this.basic.margin),
                padding: getPadding(this.advanced.padding),
                backgroundColor: this.basic.backgroundColor || null,
                boxShadow: boxShadow(this.basic.shadows),
                textShadow: multiTextShadow(this.basic.textShadows),
            };
        }
    },
    methods:{
    },
}
</script>
